import type { HoldData } from "@/api/types";

/** The longest reason a hold keeps, as the API does. */
export const NOTE_MAX = 300;

/** Why this person can't hold automatic fixes, or null when they can. */
export function holdBlocked(permissions: readonly string[]): string | null {
  return permissions.includes("promote")
    ? null
    : "Your role can't hold fixes. Admins and approvers can.";
}

/** Why this person can't lift the hold, or null when they can. */
export function liftBlocked(hold: HoldData, permissions: readonly string[]): string | null {
  if (!hold.since) {
    return "Fixes are held for this whole deployment by ZEAOPS_HOLD_FIXES. Whoever runs ZeaOps lifts that.";
  }
  return permissions.includes("admin") ? null : "Only an admin can lift the hold.";
}

/** What a hold does, in the words every screen uses. */
export const HOLD_EFFECT =
  "Every fix asks a person first, and fixes already running stop before their next change.";
